export enum ApprovalStatus {
  Pending = 'pending',
  Approved = 'approved',
  Declined = 'declined',
}
